/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_launchpad__account_modal_create = /** @type {(inputs: {}) => string} */ () => {
	return `Erstellen Sie Ihr Konto in nur wenigen Klicks`
};

const en_launchpad__account_modal_create = /** @type {(inputs: {}) => string} */ () => {
	return `Create your account in just a few clicks`
};

const es_launchpad__account_modal_create = /** @type {(inputs: {}) => string} */ () => {
	return `Cree su cuenta en unos pocos clics`
};

const fr_launchpad__account_modal_create = /** @type {(inputs: {}) => string} */ () => {
	return `Créez votre compte en quelques clics`
};

const it_launchpad__account_modal_create = /** @type {(inputs: {}) => string} */ () => {
	return `Crea il tuo account in pochi clic`
};

const nl_launchpad__account_modal_create = /** @type {(inputs: {}) => string} */ () => {
	return `Maak uw account aan in slechts enkele klikken`
};

const pt_launchpad__account_modal_create = /** @type {(inputs: {}) => string} */ () => {
	return `Crie a sua conta em poucos cliques`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_create = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.launchpad__account_modal_create(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("launchpad__account_modal_create", locale)
	if (locale === "de") return de_launchpad__account_modal_create(inputs)
	if (locale === "en") return en_launchpad__account_modal_create(inputs)
	if (locale === "es") return es_launchpad__account_modal_create(inputs)
	if (locale === "fr") return fr_launchpad__account_modal_create(inputs)
	if (locale === "it") return it_launchpad__account_modal_create(inputs)
	if (locale === "nl") return nl_launchpad__account_modal_create(inputs)
	return pt_launchpad__account_modal_create(inputs)
};